export default __webpack_public_path__ + "static/media/Revertonicon.c1cb8392.svg";